export default __webpack_public_path__ + "static/media/catho-logo.37d1b5f3.png";